import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "print-only mb-4 border-b-2 border-black pb-2",
  "data-cy": "conflict-print-masthead"
}
const _hoisted_2 = { class: "text-lg font-bold" }
const _hoisted_3 = { class: "mt-0.5 text-xs text-gray-700" }
const _hoisted_4 = {
  class: "text-xs text-gray-700",
  "data-cy": "conflict-print-run"
}
const _hoisted_5 = { class: "mt-1 text-xs text-gray-700 [overflow-wrap:anywhere]" }
const _hoisted_6 = { class: "text-xs text-gray-700 [overflow-wrap:anywhere]" }
const _hoisted_7 = { class: "text-xs text-gray-700" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs font-bold"
}

import { computed } from 'vue';
import { formatRunAt } from '../utils/conflictDateHelpers';
import type { ConflictPrintSheet } from '../models/conflictTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConflictPrintMasthead',
  props: {
    sheet: {}
  },
  setup(__props: any) {

const props = __props;

const runAt = computed(() => formatRunAt(props.sheet.runAt));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.sheet.firmName), 1),
    _createElementVNode("div", _hoisted_3, " Conflict check from LeanLaw · " + _toDisplayString(__props.sheet.saved ? 'Saved in LeanLaw' : 'Not saved in LeanLaw'), 1),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(" Run by " + _toDisplayString(__props.sheet.runByName || 'an unknown user') + " ", 1),
      (runAt.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("on " + _toDisplayString(runAt.value), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, " Searched for: " + _toDisplayString(__props.sheet.queryText), 1),
    _createElementVNode("div", _hoisted_6, _toDisplayString(__props.sheet.parties.length) + " " + _toDisplayString(__props.sheet.parties.length === 1 ? 'name' : 'names') + " checked: " + _toDisplayString(__props.sheet.parties.join(' · ')), 1),
    _createElementVNode("div", _hoisted_7, _toDisplayString(__props.sheet.includedTimeEntries
          ? 'Time entries included.'
          : 'Time entries not searched.') + " Invoice narratives are not searched. ", 1),
    (__props.sheet.hiddenRowCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.sheet.hiddenRowCount) + " result" + _toDisplayString(__props.sheet.hiddenRowCount === 1 ? '' : 's') + " hidden by the field filter and not printed. ", 1))
      : _createCommentVNode("", true)
  ]))
}
}

})